import { Injectable } from '@angular/core';

export interface ComponentCanDeactivate {
	canDeactivate: () => Promise<boolean>;
}

@Injectable()
export class PendingChangesGuard {
	async canDeactivate(component: ComponentCanDeactivate): Promise<boolean> {
		return await component.canDeactivate();
	}
}
